import { render } from "./TagDialog.vue?vue&type=template&id=89f2719c&scoped=true"
import script from "./TagDialog.vue?vue&type=script&lang=js"
export * from "./TagDialog.vue?vue&type=script&lang=js"

import "./TagDialog.vue?vue&type=style&index=0&id=89f2719c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nexty-frontend/nexty-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89f2719c"]])

export default __exports__